module.exports = __webpack_public_path__ + "img/ic_nav_star_white.9b169b21.svg";